import React from 'react';
import MeetingModal, { MODE } from '@/models/meeting';
import RTCInstanceModal from '@/models/rtc';
import { inject, observer } from 'mobx-react';
import Grid from './Grid';
import Lecturer from './Lecturer';
import Only from './Only';
import OnlyShare from './OnlyShare';
import Reconnect from './Reconnect';

interface MeetingProps {
  meeting?: MeetingModal;
  rtc?: RTCInstanceModal;
  className?: string;
}

const Meeting: React.FC<MeetingProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    rtc: store.rtc,
  };
})(
  observer(props => {
    const { meeting, rtc, className } = props;

    return (
      <div className={className}>
        {!!!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.ONLY && <Only />}
        {!!!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.GRID && <Grid />}
        {!!!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.LECTURER && <Lecturer />}
        {!!!rtc?.breakLineReconnecting && meeting?.viewMode === MODE.ONLYSHARE && <OnlyShare />}
        <Reconnect show={!!rtc?.breakLineReconnecting} />
      </div>
    );
  }),
);

export default Meeting;
